// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { FontAwesomeDetectorService } from '@services';

@Component({
  selector: 'lfx-font-awesome-alert',
  templateUrl: './font-awesome-alert.component.html',
  styleUrls: ['./font-awesome-alert.component.scss'],
  standalone: false,
})
export class FontAwesomeAlertComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  
  showAlert = false;
  isCheckPerformed = false;
  alertDismissed = false;

  constructor(private fontAwesomeDetectorService: FontAwesomeDetectorService) {}

  ngOnInit(): void {
    // Wait for the check to be performed, then show alert if Font Awesome failed to load
    this.fontAwesomeDetectorService.checkPerformed$
      .pipe(
        takeUntil(this.destroy$),
        filter(checkPerformed => checkPerformed)
      )
      .subscribe(() => {
        this.isCheckPerformed = true;
        const isLoaded = this.fontAwesomeDetectorService.isFontAwesomeLoaded();
        
        if (!isLoaded && !this.alertDismissed) {
          this.showAlert = true;
        }
      });

    // Also listen to font awesome loaded status changes
    this.fontAwesomeDetectorService.fontAwesomeLoaded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoaded => {
        if (this.isCheckPerformed) {
          this.showAlert = !isLoaded && !this.alertDismissed;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dismissAlert(): void {
    this.alertDismissed = true;
    this.showAlert = false;
  }

  retryFontAwesome(): void {
    this.fontAwesomeDetectorService.recheckFontAwesome();
    // Alert will automatically hide if Font Awesome is now working
  }
}
